
export default {
    typography: {
        fontFamily: [
            'Lato',
            'sans-serif'
        ]
    }
}